//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setIdea, updateIdea, clearIdea , setIdeaModal } from "./actions"
//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selector = (state) => state.ideas;



const selectorIdea = (state) => state.ideaModal;


export const useIdeaModal = () => {
    const selectedData = useSelector(selectorIdea, shallowEqual);
    const dispatch = useDispatch()

    const viewIdeaModal = () => {
        dispatch(setIdeaModal(true))
    }
    const hideIdeaModal = () => {
        dispatch(setIdeaModal(false))
    }

    return ({ ideaModal: selectedData, viewIdeaModal, hideIdeaModal });
}